// src/components/WhatsAppCampaignsDialog/WhatsAppCampaignsRunDialog.js

import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Button,
  Box,
  CircularProgress,
} from "@mui/material";

export default function WhatsAppCampaignsRunDialog({
  open,
  count = 0,
  loading = false,
  onClose,
}) {
  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="xs">
      <DialogTitle>Campaign Dispatch</DialogTitle>
      <DialogContent>
        <Box display="flex" flexDirection="column" alignItems="center" p={2}>
          {loading ? (
            <>
              <CircularProgress />
              <Typography variant="body1" sx={{ mt: 2 }}>
                Dispatching messages...
              </Typography>
            </>
          ) : (
            <>
              <Typography variant="h6" align="center">
                {count} messages added to the queue
              </Typography>
              <Typography variant="body2" align="center" sx={{ mt: 1 }}>
                A query has been sent to Athena to track delivery. Please check
                back in about an hour to see the results.
              </Typography>
            </>
          )}
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={loading}>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
}
